import { render, staticRenderFns } from "./TrxProject.vue?vue&type=template&id=da680b4a"
import script from "./TrxProject.vue?vue&type=script&lang=js"
export * from "./TrxProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports